import React from 'react';

const CopyIconNew = ({ stroke = "#6D7885", ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="23" viewBox="0 0 19 23" fill="none" { ...rest }>
      <path d="M6 2.6C6 2.17565 6.15804 1.76869 6.43934 1.46863C6.72064 1.16857 7.10218 1 7.5 1H17C17.5523 1 18 1.44772 18 2V15.4C18 15.8243 17.842 16.2313 17.5607 16.5314C17.2794 16.8314 16.8978 17 16.5 17H15.5" stroke={stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M2.5 6H12C12.5523 6 13 6.44804 13 7.00032V20.4C13 20.8243 12.842 21.2313 12.5607 21.5314C12.2794 21.8314 11.8978 22 11.5 22H2.5C2.10218 22 1.72064 21.8314 1.43934 21.5314C1.15804 21.2313 1 20.8243 1 20.4V7.6C1 7.17565 1.15804 6.76869 1.43934 6.46863C1.72064 6.16857 2.10218 6 2.5 6Z" stroke={stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};

export default CopyIconNew;